import { useEffect, useState } from 'react';

const MOBILE_UA_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export default function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgentIsMobile = typeof navigator !== 'undefined' && MOBILE_UA_REGEX.test(navigator.userAgent || '');
    const widthIsMobile = typeof window !== 'undefined' && window.innerWidth < breakpoint;
    setIsMobile(!!(userAgentIsMobile || widthIsMobile));

    const handleResize = () => {
      try {
        const widthMobile = window.innerWidth < breakpoint;
        setIsMobile(userAgentIsMobile || widthMobile);
      } catch (_e) {}
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
}


